import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cardIntroduction: 'In order to speed up the process, you can ask them to:',
    cta: 'Follow their progress',
    step1Title: 'Check their inbox',

    step2Title: 'Click on the invitation link sent by Shine',

    step3Substeps: ['Some information about them', 'A proof of identity'],

    step3Title: 'Complete their own information',
    subtitle:
      'We will only be able to verify your information once all beneficial owners have completed their information.',

    title: 'You need the help of the beneficial owners to open an account!',
  },

  fr: {
    cardIntroduction:
      'Pour mettre toutes les chances de votre côté, vous pouvez leur demander de\u00A0:',
    cta: 'Suivre leur progression',
    step1Title: 'Vérifier leur boîte mail',

    step2Title: 'Cliquer sur le lien d’invitation envoyé par Shine',

    step3Substeps: [
      'Quelques informations personnelles',
      'Une preuve d’identité',
    ],

    step3Title: 'Compléter eux-mêmes leurs informations',
    subtitle:
      'Nous pourrons procéder à la vérification de vos informations uniquement lorsque tous les bénéficiaires effectifs auront complété leurs informations.',

    title:
      'Vous avez besoin de l’aide des bénéficiaires effectifs pour ouvrir un compte\u00A0!',
  },
} as const);
